<template>
    <div class="container-fluid">
        <div class="row text-left" v-if="controllers == 'true'" >
			<div class="col-md-2 pb-3">
				<div class="form-group mb-0">
					<select class="form-control" v-model="pageSize" >
						<option value="10">10</option>
						<option value="25">25</option>
						<option value="50">50</option>
					</select>
				</div>
			</div>
			<div class="col-md-6 pb-3">
				<div class="form-group mb-0">
					<input type="text" v-model="search" placeholder="Pesquisar registro" class="form-control" >
				</div>
			</div>
            <div class="col-md-4 d-flex align-items-center pb-3">
                <div class="text-center container table-controllers" id="buttons">
                    <a href="#" @click.prevent="prevPage" class="btn btn-sm btn-outline-dark"  ><font-awesome-icon icon="arrow-left" /></a>
                    <a href="#" @click.prevent="firstPage" class="btn btn-sm btn-outline-dark"  >1</a>
                    <span class="btn btn-sm btn-dark"  >{{currentPage}}</span>
                    <a href="#" @click.prevent="lastPage" class="btn btn-sm btn-outline-dark"  >{{totalOfPages}}</a>
                    <a href="#" @click.prevent="nextPage" class="btn btn-sm btn-outline-dark"  ><font-awesome-icon icon="arrow-right" /></a>
                </div>
            </div>
		</div>
		
		<div class="table-responsive" >
			<table class="table table-sm table-bordered table-striped table-hover">
				<thead class="thead-dark" >
					<tr>
						<td v-for="(title, index) in titles" @click="sort(title)" :key="index" >
							{{title}}
							<i v-if="pCurrentSort === title && currentSortDir === 'asc'" class="fa fa-angle-double-down" aria-hidden="true"></i>
							<i v-if="pCurrentSort === title && currentSortDir === 'desc'" class="fa fa-angle-double-up" aria-hidden="true"></i>
						</td>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(content, index) in filterTable" :key="index" v-on:click="onClickEvent(content)" >
						<td v-for="(c, index) in content" :key="index" >
							{{c}}
						</td>
					</tr>
				</tbody>
			</table>
		</div>
        <div class="row py-2">
			<div class="col-md-12 col-12 col-lg-3 col-xl-3">
				<div class="form-group">
					<select class="form-control" v-model="pageSize" >
						<option value="10">10</option>
						<option value="25">25</option>
						<option value="50">50</option>
					</select>
				</div>
			</div>
            <div class="col-md-12 col-12 col-lg-9 col-xl-9">
                <div class="text-center container table-controllers" id="buttons" >
                    <a href="#" @click.prevent="prevPage" class="btn btn-sm btn-outline-dark"  ><font-awesome-icon icon="arrow-left" /></a>
                    <a href="#" @click.prevent="firstPage" class="btn btn-sm btn-outline-dark"  >1</a>
                    <span class="btn btn-sm btn-dark"  >{{currentPage}}</span>
                    <a href="#" @click.prevent="lastPage" class="btn btn-sm btn-outline-dark"  >{{totalOfPages}}</a>
                    <a href="#" @click.prevent="nextPage" class="btn btn-sm btn-outline-dark"  ><font-awesome-icon icon="arrow-right" /></a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'grid',
        props: [
            'controllers',
            'titles',
            'data',
            'currentSort',
            'searchKey'
        ],
        data() {
            return{ 
                pageSize		: 25,
                currentPage		: 1,
                totalOfPages	: 1,
                currentSortDir	: 'asc',
                pCurrentSort    : '',
                search			: ''
            }
        },
        methods: {
            sort: function(s){
                if(s === this.pCurrentSort){
                    this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
                }
                
                this.pCurrentSort = s;
            },
            nextPage: function(){
                if(this.currentPage+1 <= this.totalOfPages){
                    this.currentPage ++;
                }
            },
            prevPage: function(){
                if(this.currentPage - 1 >= 1){
                    this.currentPage --;
                }
            },
            firstPage: function(){
                this.currentPage = 1;
            },
            lastPage: function(){
                this.currentPage = this.totalOfPages;
            },
            onClickEvent: function(value){
                this.$emit('clicked', value)
            }
        },
        created(){
            // this.data.push({'id': 1, 'nome': 'Laravel'})
        },
        mounted(){
            this.pCurrentSort = this.currentSort
        },
        computed: {
            filterTable(){
                let filter 		  = this.search;
                let tableFiltered =  this._.orderBy(this.data, this.pCurrentSort, this.currentSortDir);
                let index 		  = Math.round((this.currentPage-1)*this.pageSize);
                
                this.totalOfPages = Math.round((tableFiltered.length / this.pageSize) + 0.4 );
                tableFiltered 	  = tableFiltered.slice(index, index + this.pageSize);
                
                if(this._.isEmpty(filter)){
                    return tableFiltered;
                }else{
                    return this._.filter(this.data, repo => repo[this.searchKey].indexOf(filter) >= 0);
                }
            }
        }
    }
</script>
<style scoped>
    #buttons .btn{
        margin: 2px;
    }

    .thead-dark{
        background: #343a40;
        color: #f8f9fa;
    }
</style>